import React, { useContext } from 'react';
import SearchInput from '../../SearchInput';
import {
 BriefingContext,
} from '../../../../containers/campanhas/Briefing';

export default function index() {
    const {
		campaign,
		gtm,
	} = useContext(BriefingContext);

	return (
		<>
			<SearchInput
				campaignRange={campaign.campaignRange}
				addRange={campaign.addRange}
				removeRange={campaign.removeRange}
				editRange={campaign.editRange}
				removeByCondition={campaign.removeByCondition}
				gtm={gtm}
			/>
		</>
	);
}
